import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { espotAPI, imagePrefix } from "../../../../public/constants/constants";
import apiManager from "../../../utils/apiManager";
import { isMobile } from "../../../utils/utilityManager";
import "../../../../public/styles/HomeInteriors/LocateUs/LocateUsMain.scss";

export default class LocateUsCity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      espotName: "GI_Interiors_LocateUs_StoreLocations",
      CitySlider: null,
      selectedCity: 0,
      slides:0,
    };
  }

  getEspotData() {
    apiManager
      .get(espotAPI + this.state.espotName)
      .then(response => {
        const { data } = response || {};
        this.setState({
          CitySlider: data.data && data.data.data,
          slides: data.data && data.data.slides,
        });
      })
      .catch(error => {
        this.setState({
          error,
          isLoading: false,
        });
      });
  }

  onSelectCity = index => {
    this.slider.slickGoTo(index);
    console.log(this.state.CitySlider[index])
    this.props.changeCity(this.state.CitySlider[index]);
    this.setState({
      selectedCity: this.state.CitySlider[index],
    });
  };

  componentDidMount() {
    this.getEspotData();
  }

  render() {
    const { CitySlider } = this.state;
    const settings = {
      slidesToShow: this.state.slides,
      infinite:false,
      slidesToScroll: 1,
      autoplay: false,
      focusOnSelect: true,
      dontAnimate: true,
      prevArrow: <button className="slide-arrow prev-arrow" />,
      nextArrow: <button className="slide-arrow next-arrow" />,
    };
    return (
      <div
        className="citySelector-container"
        onLoad={() => {
          this.onSelectCity(0);
        }}
      >
        <div className="citySelector-wrapper">
          <div className="city-header">
            <h3>Visit our experience centers near you</h3>
          </div>
          <div className="cityslider-container">
            <Slider {...settings} ref={slider => (this.slider = slider)}>
              {!!CitySlider &&
                CitySlider.map((sliderData, index) => (
                  <div
                    className="city-container"
                    onClick={() => {
                      this.onSelectCity(index);
                    }}
                  >
                    <div className="city-wrapper">
                      <img
                        className="img-City"
                        src={imagePrefix + sliderData.icon2}
                      />
                      <img
                        className="img-selected"
                        src={imagePrefix + sliderData.icon}
                      />
                      <span className="name-City">{sliderData.city}</span>
                    </div>
                  </div>
                ))}
            </Slider>
          </div>
        </div>
      </div>
    );
  }
}
